var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-1.75 0a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0ZM8.875 8v3.5h-1.75V8h1.75ZM8 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "#8698AD"
  })));
};
var Memo = /*#__PURE__*/memo(SvgInfo);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSA4QTcgNyAwIDEgMSAxIDhhNyA3IDAgMCAxIDE0IDBabS0xLjc1IDBhNS4yNSA1LjI1IDAgMSAxLTEwLjUgMCA1LjI1IDUuMjUgMCAwIDEgMTAuNSAwWk04Ljg3NSA4djMuNWgtMS43NVY4aDEuNzVaTTggNi41YTEgMSAwIDEgMCAwLTIgMSAxIDAgMCAwIDAgMloiIGZpbGw9IiM4Njk4QUQiLz48L3N2Zz4=";